export function EmailDistListImportRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailDistListImport', {
		url: '/admin/distlist/:id/contacts/import',
		controllerAs: 'vm',
		controller: EmailDistListImportCtrl,
		templateUrl: '/ng/hub/User/Import/UserImportCtrl.html?' + window.BUILD,
		permission: ['manage_groups'],
		resolve: {
			$title: () => 'Import Users',
		},
	});
}

// NOTE: this controller is very similar to
// UserImportCtrl and
// EmailContactsImportCtrl
// so any changes made here may need changing there as well
export class EmailDistListImportCtrl {
	constructor(Api, $stateParams) {
		'ngInject';
		this.Api = Api;
		this.distlistId = $stateParams.id;
		this.files = [];
		this.state = 'waiting';
		this.onlyContacts = true;
	}

	importFile(file) {
		this.state = 'processing';
		this.Api.post('/users/import/spreadsheet', {
			file: file.listItem.href,
			role: 'observer',
			distribution_list_id: this.distlistId,
		}).then(this.handleReport.bind(this));
	}

	importPaste(evt) {
		evt.preventDefault();
		this.state = 'processing';
		this.Api.post('/users/import/paste', {
			data: evt.clipboardData.getData('Text'),
			role: 'observer',
			distribution_list_id: this.distlistId,
		}).then(this.handleReport.bind(this));
		evt.target.value = '';
	}

	handleReport(report) {
		this.state = 'done';
		this.report = report;
	}
}
